export const COLUMN_WIDTH = 240;
export const CONTENT_MAX_WIDTH = 1150; 